import { ProductConfig } from "@core/interface/environment.interface";
import { ProductEnum } from "../product.enum";

export const LifeEnvironment: ProductConfig = {
    baseUrl: "",
    schemaEndpoint: "./api/v1/life-report",
    productUrl: ProductEnum.LIFE,
    skipSteps: [
        {
            skipStepName: 'payment',
            conditions: [
                {
                    stepName: 'damage-cause',
                    param: 'damageCause',
                    values: ['501']
                }, {
                    stepName: 'personal-data',
                    param: 'authorizedForInsurancePayment',
                    values: ['2']
                }
            ]
        }
    ],
    maxSingleFileSizeUpload: null,
    maxBulkFilesSizeUpload: 19000000,
    deployUrl: ProductEnum.LIFE + '/'
};